var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTwitterMobile = function SvgIconTwitterMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#777E90",
    fillRule: "evenodd",
    d: "M7.71 10.524.862 1.814h5.423l4.226 5.384 4.514-5.359h2.986l-6.057 7.198 7.182 9.149h-5.406l-4.575-5.822L4.27 18.17H1.268zm6.81 6.048L4.187 3.429h1.309l10.318 13.143z",
    clipRule: "evenodd"
  })));
};
export default SvgIconTwitterMobile;